import styled from "styled-components";

const ItemStartContent = styled.div``;

export default ItemStartContent;
